import { createTheme } from '@one-thd/sui-atomic-components';

const BlackFriday2026SecondaryOne = createTheme({
  palette: {
    mode: 'light',
    background: {
      primary: 'brand'
    }
  }
});

BlackFriday2026SecondaryOne.palette['--sui-palette-background-primary'] = '246 243 239';

export { BlackFriday2026SecondaryOne };